import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Explore() {
  const [trips, setTrips] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchTrips();
  }, []);

  const fetchTrips = async () => {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/curated-trips`
    );
    const data = await res.json();
    setTrips(data);
  };

  return (
    <div className="min-h-screen pt-24 px-4 bg-[#f7f6f1]">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
  {trips.map((trip) => (
    <div
      key={trip._id}
      onClick={() => navigate(`/curated/${trip._id}`)}
      className="bg-white rounded-2xl overflow-hidden shadow hover:scale-[1.03] transition cursor-pointer"
    >
      <div className="h-40 bg-gray-200" />

      <div className="p-3">
        <h2 className="font-semibold text-sm">{trip.title}</h2>
        <p className="text-xs text-gray-500">{trip.city}</p>
      </div>
    </div>
  ))}
</div>
         </div>
  );
}